import setQueryText from './setQueryText';
import incrementSearchKey from './incrementSearchKey';

export default () => [setQueryText(''), incrementSearchKey()];
